<p-card class="p-card container" [class.proposal-section--valid]="isCompleted && form.valid">
  @if (isDev && !isReadonly) {
    <p-button label="Simulate" class="btn--simulate" (onClick)="simulateAddress()"></p-button>
  }

  <h3 i18n>Adresse de résidence principale</h3>

  <form [formGroup]="form">
    <div class="layout__inner-card">
      <div class="layout--gap margin--bottom-medium">
        <div class="layout--full-width">
          <label class="label-top" for="street" i18n>Adresse de résidence</label>
          <input
            [ngClass]="{
              'error--input': form.controls.address.invalid && form.controls.address.touched,
            }"
            i18n-placeholder
            placeholder="Adresse de résidence"
            [formControl]="form.controls.address"
            id="street"
            type="text"
            [maxLength]="75"
            pInputText />
          @if (form.controls.address.touched) {
            @if (form.controls.address.hasError('minlength')) {
              <p class="error margin--top-smaller" i18n>Minimum de 5 caractères</p>
            }
            @if (form.controls.address.hasError('maxlength')) {
              <p class="error margin--top-smaller" i18n>Maximum de 75 caractères</p>
            }
            @if (form.controls.address.hasError('noSpecialCharacterInvalid')) {
              <p class="error margin--top-smaller" i18n>Aucun caractère spécial</p>
            }
          }
        </div>

        <div class="layout--full-width">
          <label class="label-top" for="unitNumber" i18n>Numéro d'appartement (optionnel)</label>
          <input
            [ngClass]="{
              'error--input': form.controls.unitNumber.invalid && form.controls.unitNumber.touched,
            }"
            i18n-placeholder
            placeholder="Numéro d'appartement"
            [formControl]="form.controls.unitNumber"
            id="unitNumber"
            type="text"
            [maxLength]="5"
            pInputText />
          @if (form.controls.unitNumber.touched && form.controls.unitNumber.invalid) {
            <p class="error margin--top-smaller" i18n>Maximum de 5 caractères</p>
          }
        </div>

        <div class="layout--full-width">
          <label class="label-top" for="city" i18n>Ville</label>
          <input
            [ngClass]="{
              'error--input': form.controls.city.invalid && form.controls.city.touched,
            }"
            i18n-placeholder
            placeholder="Ville"
            [formControl]="form.controls.city"
            id="city"
            type="text"
            [maxLength]="25"
            pInputText />
          @if (form.controls.city.touched) {
            @if (form.controls.city.hasError('maxlength')) {
              <p class="error margin--top-smaller" i18n>Maximum de 25 caractères</p>
            }
            @if (form.controls.city.hasError('noSpecialCharacterInvalid')) {
              <p class="error margin--top-smaller" i18n>Aucun caractère spécial</p>
            }
            @if (form.controls.city.hasError('noNumberInvalid')) {
              <p class="error margin--top-smaller" i18n>Aucun chiffre n'est permis</p>
            }
          }
        </div>

        <div class="layout--full-width">
          <label class="label-top" for="zipCode" i18n>Code postal</label>
          <input
            [ngClass]="{
              'error--input': form.controls.postalCode.invalid && form.controls.postalCode.touched,
            }"
            i18n-placeholder
            placeholder="Code postal"
            [formControl]="form.controls.postalCode"
            id="zipCode"
            mask="S0S 0S0"
            pInputText />
        </div>
      </div>
    </div>
  </form>
</p-card>
